export const PERFORMANCE_COOKIES = "C0002";
export const FUNCTIONAL_COOKIES = "C0003";
export const TARGETING_COOKIES = "C0004";
export const SOCIAL_MEDIA_TARGETING_COOKIES = "C0005";

export const FAKE_OPTANON_COOKIE_STRING =
  "version=6.28.0&isIABGlobal=false&hosts=&consentId=17ab1f7e-3934-4ac0-8896-439dc33d80ce&interactionCount=1&landingPath=NotLandingPage&groups=C0001%3A1%2CC0003%3A1%2CC0002%3A1%2CBG23%3A1%2CC0005%3A1%2CC0004%3A1%2CBG24%3A1";
